import { comics } from "@/mocks/comics";

interface ComicHeroProps {
  title: string;
  author: string;
  status: string;
  latestChapter: string;
  cover: string;
}

export default function ComicHero({ title, author, status: comicStatus, latestChapter, cover }: ComicHeroProps) {
  const handleStartReading = () => {
    const element = document.getElementById("comic-content");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="relative w-full h-[340px] md:h-[460px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={cover}
          alt={`${title} - 韩漫网高清韩国漫画`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-white mb-2 md:mb-3"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {title}
        </h1>
        <p className="text-base md:text-xl italic text-white/80 mb-1 md:mb-2"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {author}
        </p>
        <p className="text-xs md:text-sm text-white/60 mb-5 md:mb-7">
          {comicStatus} · 更新至 {latestChapter}
        </p>
        <button
          onClick={handleStartReading}
          className="inline-block px-8 md:px-10 py-3 md:py-3.5 text-sm md:text-base font-semibold bg-white text-foreground-900 rounded-full hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          开始阅读
        </button>
      </div>
    </section>
  );
}